import { render, staticRenderFns } from "./page11.vue?vue&type=template&id=8fc70200&scoped=true&"
import script from "./page11.vue?vue&type=script&lang=js&"
export * from "./page11.vue?vue&type=script&lang=js&"
import style0 from "./page11.vue?vue&type=style&index=0&id=8fc70200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc70200",
  null
  
)

export default component.exports